export default __webpack_public_path__ + "static/media/refresh.497ac870.svg";